import { Status } from '@df/core/status';
declare module '@df/session/login/login.interfaces' {
    namespace Login {
        interface IRegisterFormData {
            is_billing?: boolean;
            telephone?: string;
            fax?: string;
            confirmPassword?: string;
            store_name?: string;
            sole_prop_name?: string;
            partners_name?: string;
            directors_name?: string;
            comp_reg_num?: string;
            registered_office?: string;
            website_url?: string;
            vat_num?: string;
            business_type?: string;
            premises_type?: string;
            business_age?: string;
            acc_cont_name?: string;
            acc_cont_email?: string;
            acc_cont_phone?: string;
            max_credit?: string;
            major_brands?: string;
            bank_name?: string;
            branch_address?: string;
            bank_postcode?: string;
            account_name?: string;
            account_number?: string;
            sortcode?: string;
            date_opened?: string;
            ref_name?: string;
            ref_address?: string;
            ref_telephone?: string;
            terms_and_conditions?: boolean;
            company?: string;
            dob?: string;
            loyaltyTerms?: boolean;
        }
    }
}
export namespace NLoginForm {
    export interface IInputData {
        id: string;
        label: string;
        required?: boolean;
        status: Status;
        src?: any;
        name?: string;
        upload?: boolean;
    }
    export interface PremisesOptions {
        id?: number;
        title?: string;
    }
    export const PREMISES_OPTIONS_DEVELOPMENT = [
        {
            id: 6445,
            title: 'Premises owned'
        },
        {
            id: 6446,
            title: 'Premises rented'
        }
    ];
    export const PREMISES_OPTIONS_UAT = [
        {
            id: 7377,
            title: 'Premises owned'
        },
        {
            id: 7378,
            title: 'Premises rented'
        }
    ];
}
